import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipWhenNoEnergyUpsellProductsAvailable = (context: FlowContext): boolean => {
  const { isGasUpsellProductAvailable, isElectricityUpsellProductAvailable } = context;

  return !isGasUpsellProductAvailable && !isElectricityUpsellProductAvailable;
};
